
export default class Modal {
  constructor(trigger, container, overlay) {
    window.addEventListener('click', (event) => {
      const target = event.target;

      if (container.contains(target)) {
        overlay.style.display = 'none';
        container.style.display = 'none';
      }
    })

    trigger.addEventListener('click', (event) => {
      overlay.style.display = 'block';
      container.style.display = 'block';
      event.stopPropagation();
    });

    const close = container.querySelector('.modal-close');

    close.addEventListener('click', (event) => {
      overlay.style.display = 'none';
      container.style.display = 'none';
      event.stopPropagation();
    });

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        overlay.style.display = 'none';
        container.style.display = 'none';
        event.stopPropagation();
      }
    });
  }
}
